import { useEffect, useMemo, useState } from "react";
import { Table, Modal } from "antd";
import { TableProps } from "antd/lib/table";
import { unresolvedissuesData } from "./__mock__";
import {
  renderIssueId,
  renderVehicleId,
  renderIssueType,
  renderDueDate,
} from "./cell-renders";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { parseIssuesTable } from "utils/parsers";
import { useHistory } from "react-router-dom"; 
import { onChangeIssuesFilters } from "store/actions";
import { ISSUE_STATUS } from "utils/mapped-data";
import "styles/components/charts/unresolved-issues.scss";

const columns: TableProps<any>["columns"] = [
  {
    title: "Issue ID",
    dataIndex: "issue_id",
    render: renderIssueId,
   // width: 90,
    // className: "open-link",
  },
  {
    title: "Host ID",
    dataIndex: "issue_host_id",
   /// width: 100,
    ellipsis: true,
  },
  {
    title: "Issue Type",
    dataIndex: "issue_type",
    align: "center",
    render: renderIssueType,
  },
  {
    title: "Due Date",
    dataIndex: "due_date",
    align: "center",
    render: renderDueDate,
  },
];

export default function UnresolvedIssues() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const { userType = 1 } = useSelector((state: AppState) => state.common);
    const {
      pendingIssues,
      search,
      filters: { listType,updated },
    } = useSelector<AppState, AppState["issues"]>((state) => state.issues);
    
    // useEffect(() => {
    //   dispatch(onChangeIssuesFilters("Issue Type", ["VEHICLE_MISSING"], "list"));
    // }, [dispatch]);
    const data = useMemo(
      () => parseIssuesTable("", pendingIssues, listType),
      [pendingIssues, listType, search]
    );


  // Open the modal when "View All" is clicked
  const showModal = () => {
    history.push("/issues");
  //  setIsModalVisible(true);
  };

  // Close the modal
  const handleCancel = () => {
    setIsModalVisible(false);
  };

// Show only the top 3 issues with status "Pending"
const top3Issues = useMemo(() => {
  return data.filter(issue => ISSUE_STATUS[issue.status] === "Pending" ).slice(0, 3);
}, [data]);
  // Define columns for the main table without the Due Date
  const mainTableColumns = (columns || []).filter(column => column.title !== "Due Date");

  return (
    <>
      <section className="dashboard-table-header">
        <h3 style={{ margin: 0 }}>Pending Issues</h3>
        {userType !== 2 && (
    <a className="dashboard-table-link" onClick={showModal}>
      View All
    </a>
  )}
      </section>

      <Table
        className="--top5-table custom-scrollbar"
        // rowClassName="dashed-border "
        dataSource={top3Issues} // Show top 3 issues only
        columns={mainTableColumns} // Use the main table columns without the Due Date
        pagination={false}
        scroll={{ y: 200 }}
      />

      {/* Modal to display all data */}
      <Modal
      //  title="All Pending Issues"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={800} // Adjust width as needed
      >
        <Table
          className="--top5-table custom-scrollbar"
          dataSource={unresolvedissuesData} // Show all data
          columns={columns} // Use all columns for the modal
          pagination={false}
          scroll={{ y: 300 }} // Adjust scroll height as needed
        />
      </Modal>
    </>
  );
}
